import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';
import { Icon } from './_base';

const CancelledSVG = styled(Icon).attrs({ viewBox: '0 0 38 40' })`
    width: 0.95em;
`;

const Cancelled = ({ color = navy, ...props }) => (
    <CancelledSVG data-test="icon-canceled" {...props}>
        <path
            d="M21.05,3.14V0H16V3.14A18.52,18.52,0,1,0,21.05,3.14ZM18.52,35.63A14.15,14.15,0,1,1,32.66,21.48,14.16,14.16,0,0,1,18.52,35.63Z"
            fill={color}
        />
        <polygon
            fill={color}
            points="23.65 13.48 18.52 18.61 13.39 13.48 10.52 16.35 15.65 21.48 10.52 26.61 13.39 29.48 18.52 24.35 23.65 29.48 26.52 26.61 21.39 21.48 26.52 16.35 23.65 13.48"
        />
    </CancelledSVG>
);

export { Cancelled as default, Cancelled };
